import {Expose, Type} from 'class-transformer';

export class RenewalLog {
    start: string = null;
    stop: string = null;
    @Expose({name: 'logs_aggregated_per_sub_product'})
    @Type(() => LogAggregatedPerSubProduct)
    logsAggregatedPerSubProduct: LogAggregatedPerSubProduct[] = null;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class LogAggregatedPerSubProduct {
    @Expose({name: 'sub_product_name'})
    subProductName: string = null;
    @Expose({name: 'sub_product_code'})
    subProductCode: string = null;
    @Expose({name: 'logs_aggregated_per_group'})
    @Type(() => LogAggregatedPerGroup)
    logsAggregatedPerGroup: LogAggregatedPerGroup[] = null;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class LogAggregatedPerGroup {
    @Expose({name: 'group_name'})
    groupName: string = null;
    @Expose({name: 'logs_aggregated_per_process'})
    @Type(() => LogAggregatedPerProcess)
    logsAggregatedPerProcess: LogAggregatedPerProcess[] = null;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class LogAggregatedPerProcess {
    @Expose({name: 'process_name'})
    processName: string = null;
    @Expose({name: 'process_code'})
    processCode: string = null;
    successes: number = null;
    failures: number = null;
    total: number = null;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class RenewalLogDetailedReportParams {
    start: string;
    stop: string;
    subProductCode: string;
    processCode: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
